<section class="organization-invite-setup-shell">
  <div class="organization-invite-setup-card">
    <img :src="$clientLogo" class="organization-invite-setup-logo" alt="" />
    <h1>Complete Your Organisation Invite</h1>
    <p>Set up your name and password to continue.</p>

    <div v-if="errors.form" class="alert alert-danger text-xs py-2" role="alert">
      {{ errors.form }}
    </div>

    <div v-if="is_loading_invite" class="alert alert-light text-xs py-2" role="status">
      Loading invite details...
    </div>

    <form @submit.prevent="submit_invite_setup">
      <div class="organization-invite-setup-grid">
        <div v-if="requires_email" class="organization-invite-setup-span">
          <label class="form-label text-xs fw-500" for="invite_setup_email">Email <span class="text-danger">*</span></label>
          <input id="invite_setup_email" v-model="form.email" :class="['form-control rounded-5 text-xs p-2', { 'is-invalid': errors.email }]" type="email" placeholder="example@company.com" />
          <div v-if="errors.email" class="invalid-feedback text-xs">{{ errors.email }}</div>
        </div>
        <div>
          <label class="form-label text-xs fw-500" for="invite_setup_first_name">First Name <span class="text-danger">*</span></label>
          <input id="invite_setup_first_name" v-model="form.first_name" :class="['form-control rounded-5 text-xs p-2', { 'is-invalid': errors.first_name }]" type="text" placeholder="Enter first name" />
          <div v-if="errors.first_name" class="invalid-feedback text-xs">{{ errors.first_name }}</div>
        </div>

        <div>
          <label class="form-label text-xs fw-500" for="invite_setup_last_name">Last Name <span class="text-danger">*</span></label>
          <input id="invite_setup_last_name" v-model="form.last_name" :class="['form-control rounded-5 text-xs p-2', { 'is-invalid': errors.last_name }]" type="text" placeholder="Enter last name" />
          <div v-if="errors.last_name" class="invalid-feedback text-xs">{{ errors.last_name }}</div>
        </div>

        <div class="organization-invite-setup-span">
          <label class="form-label text-xs fw-500" for="invite_setup_password">Password <span class="text-danger">*</span></label>
          <div class="position-relative">
            <input id="invite_setup_password" v-model="form.password" :class="['form-control rounded-5 text-xs p-2', { 'is-invalid': errors.password }]" :type="password_visible ? 'text' : 'password'" placeholder="Enter password" />
            <button class="organization-invite-setup-eye" type="button" @click="password_visible = !password_visible">
              <i :class="password_visible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
            </button>
            <div v-if="errors.password" class="invalid-feedback text-xs">{{ errors.password }}</div>
          </div>
        </div>

        <div class="organization-invite-setup-span">
          <label class="form-label text-xs fw-500" for="invite_setup_confirm_password">Confirm Password <span class="text-danger">*</span></label>
          <div class="position-relative">
            <input id="invite_setup_confirm_password" v-model="form.confirm_password" :class="['form-control rounded-5 text-xs p-2', { 'is-invalid': errors.confirm_password }]" :type="confirm_password_visible ? 'text' : 'password'" placeholder="Confirm password" />
            <button class="organization-invite-setup-eye" type="button" @click="confirm_password_visible = !confirm_password_visible">
              <i :class="confirm_password_visible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
            </button>
            <div v-if="errors.confirm_password" class="invalid-feedback text-xs">{{ errors.confirm_password }}</div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary rounded-5 shadow-sm w-100 mt-3" type="submit" :disabled="is_submitting || is_loading_invite || !invitation_token">
        {{ is_submitting ? 'Saving...' : 'Complete Setup' }}
      </button>
    </form>
  </div>
</section>
